<template>
  <div class="div">
    <div class="rectangle-8"></div>
    <div class="group-46">
      <div class="rectangle-9"></div>
      <button class="nav-button prev-button" @click="$emit('close')">
        <span>이전</span>
      </button>
    </div>
    <button class="nav-button next-button"
     @click="onClickApply"
     :disabled="!isNextButtonEnabled"
     >
      <span>신청</span>
    </button>
    <!-- 숫자 버튼들 -->
    <div v-for="(num, index) in numbers" :key="`container-${num}`">
      <div 
        :class="['ellipse2', `ellipse2-${index + 1}`, { 'active': activeNumber === num }]"
        @click="handleNumberClick(num)"
      ></div>
      <div 
        :class="`_${num}`"
        @click="handleNumberClick(num)"
      >{{ num }}</div>
    </div>
    <div 
      class="ellipse2 ellipse2-12"
      @click="deleteNumber"
    >
      <img class="cancelImg" src="/static/salesReservation/cancelNum.png" alt="취소" />
    </div>
    <div class="group-80">
      <div class="rectangle-7"></div>
      <div class="juminNo">
        <span>
          <span :class="['juminNo-span', 'input-1']">
            <span class="entered">{{ juminNo1 }}</span>
            <span>{{ juminPlaceholder1 }}</span>
          </span> -
          <span :class="['juminNo-span', 'input-2']">
            <span class="entered">{{ formatJuminNo(juminNo2)}}</span>
            <span>{{ formatJuminNo(juminPlaceholder2)}}</span>
          </span>
        </span>
      </div>
      <div class="div4" :class="{ 'error-message': showErrorMessage }">
        {{ infoMessage }}
      </div>
      <div class="div5">
        <span>
          <span class="div-5-span">고객님의 주민번호</span>
          <span class="div-5-span2">
            를
            <br />
            입력해주세요.
          </span>
        </span>
      </div>
    </div>
    <div class="rectangle-48"></div>
    <div class="group-92">
      <div class="group-89">
        <div class="div6">
          보험 상담을 신청하고
          <br />
          무료로 커피를 받아가세요!
        </div>
        <div class="event">커피 무료 증정 EVENT</div>
      </div>
      <img class="_6024370-1" src="/static/salesReservation/coffee.png" />
    </div>

    <div v-if="showPopup" class="popup-overlay">
      <div class="popup-content">
        <img class="div10" src="/static/salesReservation/clab.png" />
        <div class="div8">상담 신청이 완료되었습니다.</div>
        <div class="div7">
          카카오톡 알림톡을 확인해주세요!
          <div class="underline"></div>
        </div>
        <div class="div9" @click="closePopup">이전 페이지로 돌아가기</div>
      </div>
    </div>


  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    refin: { type: String, default: '' },
    sorce: { type: String, default: '' },
    pn: { type: String, default: '' }, // 전화번호
    me: { type: String, default: '' }, // 선택한 보험
    cname: { type: String, default: '' }, // 고객 이름
  },
  emits: ['resetValue'],
  data() {
    return {
      juminNo1: '',
      juminNo2: '',

      juminPlaceholder1: '',
      juminPlaceholder2: '',

      currentInput: 1,
      activeNumber: null,
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0'],
      infoMessage: '정보 입력 후 접수 신청 시 개인정보 활용에 동의한 것으로 간주됩니다.',
      showErrorMessage: false,
      csn: '',
      showPopup: false,
    };
  },
  computed: {
    isNextButtonEnabled() {
      return (
        this.csn.length === 13
        // this.juminNo1.length === 6 &&
        // this.juminNo2.length === 7 &&
        // this.juminNo2 !== '0000000'
      );
    }
  },
  mounted() {
    this.csn = '';
    this.__renderInputValue();
    // console.log('cname:', this.cname);
  },

  methods: {
    //3cx모듈 (7자리 숫자가 있을 때 전화번호로 인식하는 모듈 방지용)
    formatJuminNo(num) {
      return num.split('').join('\u200B');
    },

    __renderInputValue() {
      this.juminNo1 = this.csn.substring(0, 6);
      this.juminPlaceholder1 = '000000'.substring(0, 6 - this.juminNo1.length);
      this.juminNo2 = this.csn.substring(6);
      this.juminPlaceholder2 = '0000000'.substring(0, 7 - this.juminNo2.length);
    },

    appendNumber(num) {
      if (num === '' || this.csn.length >= 13) {
        return;
      }

      const newCsn = this.csn + num;
      const validationResult = this.validateInput(newCsn);

      if (validationResult.isValid) {
        this.csn = newCsn;
        this.__renderInputValue();
      } else {
        this.showErrorMessage = true;
        this.infoMessage = validationResult.message;
        this.csn = validationResult.correctedCsn;

        this.resetErrorMessage();
      }
    },

    validateInput(csn) {
      if (csn.length === 4) {
        return this.validateMonth(csn);
      }
      if (csn.length === 6) {
        return this.validateDay(csn);
      }
      if (csn.length === 7) {
        return this.validateGender(csn);
      }
      return { isValid: true, correctedCsn: csn };
    },

    validateMonth(csn) {
      const month = parseInt(csn.slice(2,4));
      if (month < 1 || month > 12) {
        return {
          isValid: false,
          message: '월은 01 - 12 사이 숫자만 입력 가능합니다',
          correctedCsn: csn.slice(0, -2)
        };
      }
      return { isValid: true, correctedCsn: csn };
    },

    validateDay(csn) {
      const day = parseInt(csn.slice(4,6));
      if (day < 1 || day > 31) {
        return {
          isValid: false,
          message: '날짜는 01 - 31 사이 숫자만 입력 가능합니다',
          correctedCsn: csn.slice(0, -2)
        };
      }
      return { isValid: true, correctedCsn: csn };
    },

    validateGender(csn) {
      const genderDigit = parseInt(csn.slice(6, 7));
      if (genderDigit < 1 || genderDigit > 4) {
        return {
          isValid: false,
          message: '주민등록번호 뒷자리의 첫 번째 숫자는 1에서 4 사이여야 합니다',
          correctedCsn: csn.slice(0, -1)
        };
      }
      return { isValid: true, correctedCsn: csn };
    },

    resetErrorMessage() {
      setTimeout(() => {
        this.showErrorMessage = false;
        this.infoMessage = '정보 입력 후 접수 신청 시 개인정보 활용에 동의한 것으로 간주됩니다.';
        this.__renderInputValue();
      }, 3000);
    },

    deleteNumber() {
      this.csn = this.csn.slice(0, -1);
      this.__renderInputValue();
    },
    onClickApply() {
      if (this.isNextButtonEnabled) {
        this.csn = `${this.juminNo1}${this.juminNo2}`;
        this.sendApi() 
      }
    },
    closePopup() {
      this.showPopup = false;
      this.resetValue();  
      this.$router.replace('/');
    },

    sendApi() {
      const baseUrl = 'https://asia-northeast3-qprice-db76b.cloudfunctions.net/reservationagent';
      const params = {
        cname: this.cname, //고객명
        csn: this.csn, // 주민번호
        pn: this.pn, // 전화번호
        so: this.sorce, // url파라미터의 source
        re: this.refin, // url파라미터의 refin
        me: this.me // 선택한 보험종목
      };

      const url = new URL(baseUrl);
      Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

      axios.get(url.toString())
        .then(response => {
        })
        .catch(error => {
        });
        this.showPopup = true;
    },

    handleNumberClick(num) {
      this.activeNumber = num;
      this.appendNumber(num);
    },

    resetValue() {
      this.juminNo1 = '000000';
      this.juminNo2 = '0000000';
      this.$emit('resetValue')
    }
  }
}
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");

body, .div, .div * {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  box-sizing: border-box;
}

.div {
  background: #ffffff;
  width: 1194px;
  height: 834px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 40px;
  box-sizing: border-box;
}

.rectangle-8 {
  background: #184de5;
  border-radius: 50px;
  width: 172px;
  height: 64px;
  position: absolute;
  left: calc(50% - -320px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.group-46 {
  width: 172px;
  height: 64px;
  position: static;
}

.rectangle-9 {
  background: var(--grays-gray-3, #c7c7cc);
  border-radius: 50px;
  width: 172px;
  height: 64px;
  position: absolute;
  left: calc(50% - -128px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.nav-button {
  width: 172px;
  height: 64px;
  border-radius: 50px;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-button span {
  color: #ffffff;
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.03em;
  text-orientation: upright;
}

.nav-button:disabled {
  background-color: var(--grays-gray-3, #c7c7cc);
  cursor: not-allowed;
}

.prev-button {
  left: calc(50% - -128px);
  top: calc(50% - -156px); /* 242px - 86px */
}

.next-button {
  background: #184de5;
  left: calc(50% - -320px);
  top: calc(50% - -156px); /* 242px - 86px */
}


.ellipse2 {
  background: #ffffff;
  border-radius: 50%;
  border-style: solid;
  border-color: var(--grays-gray-4, #d1d1d6);
  border-width: 2px;
  width: 100px;
  height: 100px;
  position: absolute;
  cursor: pointer;
}

.ellipse2.active {
  border-color: #184de5;
}

.ellipse2-1 { left: 690px; top: -60px; }
.ellipse2-2 { left: 822px; top: -60px; }
.ellipse2-3 { left: 954px; top: -60px; }
.ellipse2-4 { left: 690px; top: 60px; }
.ellipse2-5 { left: 822px; top: 60px; }
.ellipse2-6 { left: 954px; top: 60px; }
.ellipse2-7 { left: 690px; top: 180px; }
.ellipse2-8 { left: 822px; top: 180px; }
.ellipse2-9 { left: 954px; top: 180px; }
.ellipse2-10 { left: 690px; top: 300px; }
.ellipse2-11 { left: 822px; top: 300px; }
.ellipse2-12 {
  left: 994px;
  top: 403px;
  display: flex;
  justify-content: center;
  align-items: center;
}

._1 { left: 732px; top: -35px; }
._2 { left: 862px; top: -35px; }
._3 { left: 993px; top: -35px; }
._4 { left: 729px; top: 85px; }
._5 { left: 862px; top: 85px; }
._6 { left: 993px; top: 85px; }
._7 { left: 730px; top: 205px; }
._8 { left: 861px; top: 205px; }
._9 { left: 993px; top: 205px; }
._0 { left: 862px; top: 325px; }
._010 { left: 710px; top: 325px; }

._1, ._2, ._3, ._4, ._5, ._6, ._7, ._8, ._9, ._0 {
  color: #000000;
  text-align: center;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  cursor: pointer;
}

._010 {
  color: #000000;
  text-align: center;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  cursor: default;
}
.ellipse2-10 {
  border-color: var(--grays-gray-4, #d1d1d6);
  cursor: default;
}

.ellipse2-10:hover {
  border-color: var(--grays-gray-4, #d1d1d6);
}

.ellipse2-10.active {
  border-color: var(--grays-gray-4, #d1d1d6);
}



.cancelImg {
  width: 50px;
  height: 25px;
  cursor: pointer;
}


.group-80 {
  width: 540px;
  height: 306px;
  position: static;
}

.rectangle-7 {
  background: #ffffff;
  border-radius: 36px;
  border-style: solid;
  border-color: #184de5;
  border-width: 3.5px;
  width: 540px;
  height: 80px;
  position: absolute;
  left: calc(50% - 492px);
  top: calc(50% - 171px); /* -85px - 86px */
}

.juminNo {
  text-align: left;
  font-size: 42px;
  line-height: 150%;
  letter-spacing: 0.12em;
  font-weight: 500;
  position: absolute;
  left: 157px;
  top: 255px; /* 341px - 86px */
}

.juminNo-span {
  color: var(--grays-gray-2, #aeaeb2);
}

.juminNo-span.input-1 {
  width: 176px;
}

.juminNo-span .entered {
  color: #000000;
}

.div4 {
  color: var(--grays-gray, #8e8e93);
  text-align: left;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  left: 178px;
  top: 340px;
  transition: color 0.3s ease;
}
.error-message {
  color: red;
}


.div5 {
  color: #000000;
  text-align: left;
  font-size: 44px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 400;
  position: absolute;
  left: calc(50% - 492px);
  top: 55px; /* 141px - 86px */
}

.div-5-span {
  font-weight: 600;
}

.div-5-span2 {
  font-weight: 500;
}

.rectangle-48 {
  background: rgba(24, 77, 229, 0.05);
  border-radius: 20px;
  width: 380px;
  height: 148px;
  position: absolute;
  left: 105px;
  top: 489px; /* 575px - 86px */
}

.group-92 {
  width: 309px;
  height: 100px;
  position: static;
}

.group-89 {
  width: 184px;
  height: 76px;
  position: static;
}

.div6 {
  color: #000000;
  text-align: left;
  font-size: 16px;
  line-height: 140%;
  font-weight: 500;
  position: absolute;
  left: 266px;
  top: 557px; /* 643px - 86px */
}

.event {
  color: #000000;
  text-align: left;
  font-size: 20px;
  font-weight: 800;
  position: absolute;
  left: 266px;
  top: 525px; /* 611px - 86px */
}

._6024370-1 {
  border-radius: 20px;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 141px;
  top: 513px; /* 599px - 86px */
  object-fit: cover;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 반투명 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 다른 요소들 위에 표시 */
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  background: #ffffff;
  border-radius: 20px;
  width: 520px;
  height: 360px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.vector-10 {
  width: 130px;
  height: 0px;
  position: absolute;
  left: 464px;
  top: 458.5px;
  transform: translate(0px, -0.5px);
  overflow: visible;
}
.div8 {
  color: #000000;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
}

.div7 {
  color: #000000;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}

.underline {
  position: absolute;
  bottom: -5px;
  left: 25%;
  transform: translateX(-50%);
  width: 130px;
  height: 1px;
  background-color: #000000;
}

.div9 {
  color: #919191;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 50px;
}

.div10 {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}
</style>
